import * as c from './types';

export const setTranslationLocale = (payload) => ({
  type: c.SET_TRANSLATION_LOCALE,
  payload
});
